// src/ui/retry-card.js — card de error/"Reintentar" reusable para las vistas
// internas (DT-H3-resto, 6-jun-2026). Cuando una carga de red falla/timeoutea,
// la vista muestra esto en vez de quedar en spinner eterno.

export const retryCardHTML = (titulo = 'No se pudo cargar') => `
    <div class="glass-card view-enter" style="text-align:center; margin-top:1.5rem;">
        <h2 style="font-family:var(--font-heading); color:var(--white); font-size:1.15rem; margin-bottom:.5rem;">${titulo}</h2>
        <p class="subtitle" style="margin-bottom:1rem;">Revisá tu conexión y probá de nuevo.</p>
        <button class="btn btn-primary" type="button" data-retry style="min-height:46px;">Reintentar</button>
    </div>`

// Cablea el botón [data-retry] dentro de `root` para que ejecute `retryFn`.
export const wireRetry = (root, retryFn) => {
  root?.querySelector?.('[data-retry]')?.addEventListener('click', retryFn)
}
